import { useTranslation } from 'next-i18next';
import styles from '@features/cms/components/categories/CategoryGalleryBlock/components/Filters/Filters.styles';
import Button from '@components/Button/Button';
import CategoryGalleryStore from '@features/cms/components/categories/CategoryGalleryBlock/mobx/store/CategoryGalleryStore';
import Icon from '@components/icons/Icon';
type PropsType = {
  categoryStore: CategoryGalleryStore;
};
const Filters = ({
  categoryStore
}: PropsType) => {
  const {
    selectedFiltersState,
    openAside
  } = categoryStore;
  const {
    t
  } = useTranslation('filters');
  return <div sx={styles.availableFilters} data-testid="category-gallery-block-filters">
      <Button variant="outlined" size="small" variantColor="dark" addSx={styles.buttonStandard} onClick={() => openAside('')} data-testid="category-gallery-block-filters-all-filters-button">
        <span className="buttonText" data-testid="category-gallery-block-filters-all-filters-button-text">
          {t('allFilters')}
        </span>
        <Icon icon="Filter" size="16px" margin="0 0 0 16px" />
      </Button>

      {selectedFiltersState && selectedFiltersState.getAttributesCount() > 0 && selectedFiltersState.attributes.map(filter => {
      const selectedValuesCount = filter.getValuesCount();
      const isSelected = selectedValuesCount > 0;
      if (isSelected) {
        return <Button key={filter.name} variant="default" size="small" variantColor="lightGrey" addSx={styles.buttonActiveFilter} onClick={() => openAside(filter.code)} data-testid={`category-gallery-block-filters-filter-${filter.code}`}>
                {filter.name} ({selectedValuesCount})
                <Icon icon="ChevronRight" size="24px" margin="0 0 0 8px" ariaHidden />
              </Button>;
      }
      return <Button key={filter.name} variant="outlined" size="small" addSx={styles.buttonFilter} onClick={() => openAside(filter.code)} data-testid={`category-gallery-block-filters-filter-${filter.code}`}>
              {filter.name}
              <Icon icon="ChevronRight" size="24px" margin="0 0 0 8px" ariaHidden />
            </Button>;
    })}
    </div>;
};
export default Filters;